// https://usehooks.com/useWindowSize/
import React, {useState, useEffect, createContext, useContext, useLayoutEffect} from "react";

export interface IWindowSizeState {
  width: number;
  height: number;
}

export const WindowSizeContext = createContext({} as IWindowSizeState);

export const WindowSizeContextProvider: React.FunctionComponent = ({
  children,
}) => {
  const [windowSize, setWindowSize] = useState<IWindowSizeState>({
    width: 0,
    height: 0,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <WindowSizeContext.Provider value={windowSize}>
      {children}
    </WindowSizeContext.Provider>
  );
};

export const WindowSizeConsumer = WindowSizeContext.Consumer;

export const useWindowSize = (): IWindowSizeState =>
  useContext(WindowSizeContext);
